import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "layout__wrapper" }

import { computed, onBeforeMount, ref } from 'vue'
import { useWait } from '@/app/composables/useWait'
import { onBeforeRouteUpdate, useRouter } from 'vue-router'
import { backend } from '@/services/backend'
import type {
  CustomListWithDocs,
  Doc,
  DocsUserDataResponse,
} from '@/models/interfaces'

import Layout from '@/app/components/Layout.vue'
import LibraryHome20321 from '@/app/components/library/LibraryHome20321.vue'

import { initializeFirstLaunchList } from '@/models/onboarding'
import { saveForLater20321Treatment } from '@/services/ab/experiments'


export default /*@__PURE__*/_defineComponent({
  __name: 'MyLibrary',
  setup(__props) {

const docsUserData = ref<DocsUserDataResponse | null>(null)
const docs = ref<Doc[] | null>(null)
const lists = ref<CustomListWithDocs[] | null>(null)
const wait = useWait()
const router = useRouter()
let initialDataLoad: Promise<void> | null = null

const showNewLibrary20321 = computed(() => {
  return (
    saveForLater20321Treatment() &&
    router.currentRoute.value.name === 'my_library.books'
  )
})

onBeforeMount(() => {
  initialDataLoad = loadDocuments()
})

onBeforeRouteUpdate(async (to) => {
  // This reloads lists when switching from a different My Library tab to
  // Lists. That first tab could have mutated the lists (e.g. from adding to a
  // new list using a book card's menu), so the reload is necessary to update
  // the list data.
  if (to.name === 'my_library.custom_lists') {
    // Wait for the loadDocuments() from the earlier tab to finish, so that
    // the old list data does not overwrite the reloaded lists.
    // Addresses #19366.
    if (initialDataLoad) {
      await initialDataLoad
    }
    try {
      lists.value = await backend.getCustomLists()
    } catch (error) {
      Sentry?.captureException(error)
    }
  }
})

const loadDocuments = async (): Promise<void> => {
  try {
    wait.start('Loading Docs')
    wait.end('Error Loading Docs')

    // Initialize Want to Read before loading, so that the seeded docs are
    // shown on first load.
    await initializeFirstLaunchList()

    const [userData, docsData, listsData] = await Promise.all([
      backend.getDocsUserData(),
      backend.getUserDocs(),
      backend.getCustomLists(),
    ])

    docsUserData.value = userData
    docs.value = docsData
    lists.value = listsData
  } catch (error: any) {
    if (error.request && error.request.status === 404) {
      router.push({ name: 'not_found' })
    } else {
      wait.start('Error Loading Docs')
      if (Sentry) {
        Sentry.captureException(error)
      }
    }
  } finally {
    wait.end('Loading Docs')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LoadingError = _resolveComponent("LoadingError")!

  return (_unref(wait).is('Loading Docs'))
    ? (_openBlock(), _createBlock(Layout, {
        key: 0,
        showUpgradePromptModal: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_loading_spinner)
          ])
        ]),
        _: 1
      }))
    : (showNewLibrary20321.value && docsUserData.value && docs.value && lists.value)
      ? (_openBlock(), _createBlock(LibraryHome20321, {
          key: 1,
          docsUserData: docsUserData.value,
          docs: docs.value,
          lists: lists.value
        }, null, 8, ["docsUserData", "docs", "lists"]))
      : (docsUserData.value && docs.value && lists.value)
        ? (_openBlock(), _createBlock(_component_router_view, {
            key: 2,
            docsUserData: docsUserData.value,
            docs: docs.value,
            lists: lists.value
          }, null, 8, ["docsUserData", "docs", "lists"]))
        : (
      (!docsUserData.value || !docs.value || !lists.value) && _unref(wait).is('Error Loading Docs')
    )
          ? (_openBlock(), _createBlock(Layout, {
              key: 3,
              showUpgradePromptModal: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_LoadingError)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
}
}

})